import { NextPage } from 'next';

import RentalSearchTemplate from '@/components/templates/RentalSearchTemplate';

interface IError {
  statusCode: number;
  message?: string;
}

interface IProps {
  error: IError | null;
}

const SearchPage: NextPage<IProps> = () => {
  return <RentalSearchTemplate />;
};

export default SearchPage;
